import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateSystemUiModule(
    $id: String!
    $data: updateSystemUiModuleInput!
  ) {
    updateSystemUiModule(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateSystemUiModuleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateSystemUiModuleInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_ui_module/update_system_ui_module',
  async (
  params: {id: String;data: TYPES.UpdateSystemUiModuleInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateSystemUiModule;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateSystemUiModuleSlice = createSlice({
  name: 'update_system_ui_module',
  initialState: initialState,
  reducers: {
    updateSystemUiModuleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateSystemUiModuleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateSystemUiModuleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateSystemUiModuleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateSystemUiModuleClear } =
updateSystemUiModuleSlice.actions;

export const updateSystemUiModule = createSelector(
  (state: RootState) => state.systemUiModule.updateSystemUiModule.result,
  (state: RootState) => state.systemUiModule.updateSystemUiModule.error,
  (state: RootState) => state.systemUiModule.updateSystemUiModule.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateSystemUiModuleSlice.reducer;